import { Track } from '../types';
import './BlankCard.css';

/**
 * Компонент одного бланка для игры "Музыкальное Лото"
 * Отображает сетку 5x5 с треками
 */
interface BlankCardProps {
  tracks: Track[];
  pageNumber: number;
}

export const BlankCard = ({ tracks, pageNumber }: BlankCardProps) => {
  // Перемешиваем треки для этого бланка
  const shuffledTracks = [...tracks];
  for (let i = shuffledTracks.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledTracks[i], shuffledTracks[j]] = [shuffledTracks[j], shuffledTracks[i]];
  }

  return (
    <div className="blank-card">
      <div className="blank-card-header">
        {/* Иконки в шапке - можно заменить на свои изображения */}
        <div className="blank-card-header-icons">
          <span className="blank-card-header-icon">🎵</span>
          <span className="blank-card-header-icon">🎶</span>
          <span className="blank-card-header-icon">🎤</span>
        </div>
        <h1>Музыкальное Лото</h1>
        <div className="blank-card-header-line"></div>
      </div>
      
      <table className="blank-card-grid">
        <tbody>
          {Array.from({ length: 5 }).map((_, row) => (
            <tr key={row}>
              {Array.from({ length: 5 }).map((_, col) => {
                const cellIndex = row * 5 + col;
                const track = shuffledTracks.length > 0 
                  ? shuffledTracks[cellIndex % shuffledTracks.length]
                  : null;

                return (
                  <td key={col} className="blank-card-cell">
                    {track ? (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <div className="blank-card-artist">{track.artist}</div>
                        <div className="blank-card-title">{track.title}</div>
                      </div>
                    ) : (
                      <div className="blank-card-empty">—</div>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="blank-card-footer">
        Бланк № {pageNumber}
      </div>
    </div>
  );
};

